import React from "react";

export default function ProficiencyLevels_VN() {
  return (
    <>
      <h2>Giải thích mức độ thành thạo</h2>
      <div>
      Để hiểu rõ hơn về hồ sơ năng lực cá nhân của bạn, bạn nên xem xét kết quả của mình theo từng lĩnh vực. Điều này sẽ giúp bạn có một ý tưởng ban đầu để xác định những điểm mạnh và yếu tương đối của mình, đồng thời nó cũng cung cấp cho bạn các gợi ý và ý tưởng để phát triển thêm về năng lực số của mình.
        <ul>
          <li>Cấp độ A: 0/192 điểm, 0%</li>
          <li>Cấp độ B: dưới 64/192 điểm, lên đến 33%</li>
          <li>Cấp độ C: 65-128/192 điểm, 34-67%</li>
          <li>Cấp độ D: 129-192/192 điểm, 6-100%</li>
        </ul>
      </div>
      <div>
        <h3>Mức độ A: Chưa làm quen với kỹ thuật số</h3>
        <div style={{ marginBottom: "20px" }}>
        Bạn đang ở giai đoạn đầu của hành trình kỹ thuật số trong giáo dục. Có lẽ thế giới rộng lớn của các công cụ và kỹ thuật số khiến bạn cảm thấy xa lạ và choáng ngợp. Mặc dù bạn có thể chưa khám phá hoặc sử dụng nhiều (nếu có) chiến lược kỹ thuật số trong việc giảng dạy của mình, nhưng bạn thực sự có tính tò mò và sẵn sàng học hỏi. Khi bạn bắt đầu cuộc hành trình này, hãy nhớ rằng mọi người đều sẽ bắt đầu từ một điểm nào đó. Với các nguồn lực và sự hỗ trợ phù hợp, bạn sẽ sớm tìm được chỗ đứng của mình, khám phá những khả năng vộ tận mà việc tích hợp kỹ thuật số mang lại nhằm nâng cao chất lượng giảng dạy.
        </div>
      </div>
      <div>
        <h3>Mức độ B: Người mới bắt đầu với kỹ thuật số </h3>
        <div style={{ marginBottom: "20px" }}>
        Bạn có thể đã thử một số công cụ kỹ thuật số, và bạn đang suy nghĩ về cách tích hợp chúng một cách nhất quán hơn. Khi bạn tìm hiểu sâu hơn, bạn sẽ mong muốn khám phá các cách mà những công cụ này có thể hỗ trợ cho chiến lược giảng dạy của bạn, từ đó bạn sẽ khám phá và thử nghiệm chúng trong các bối cảnh khác nhau.
        </div>
      </div>
      <div>
        <h3>Mức độ C: Người thực hành kỹ thuật số</h3>
        <div style={{ marginBottom: "20px" }}>
        Bạn đã vượt qua những điều cơ bản và đang tích hợp các công nghệ số vào các hoạt động hàng ngày của bạn. Hộp công cụ của bạn về các chiến lược kỹ thuật số đang mở rộng, và bạn có kỹ năng lựa chọn công cụ phù hợp cho mỗi tình huống. Bạn nhận ra cả điểm mạnh và điểm yếu của các phương pháp kỹ thuật số khác nhau. Bằng cách thử nghiệm và phản ánh liên tục, bạn đang điều chỉnh và hoàn thiện phương pháp của mình. Và khi kiến thức của bạn ngày càng phong phú, bạn cũng đang chia sẻ thông tin và hướng dẫn đồng nghiệp của mình trên hành trình kỹ thuật số của họ.
        </div>
      </div>
      <div>
        <h3>Cấp độ D: Nhà đổi mới kỹ thuật số</h3>
        <div style={{ marginBottom: "20px" }}>
        Bạn đi đầu trong việc đổi mới kỹ thuật số trong giáo dục. Bạn có cách tiếp cận đa chiều trong việc ứng dụng công nghệ kỹ thuật, điều này cho phép bạn lựa chọn những chiến lược tốt nhất một cách nhất quán. Bạn không chỉ là một người sử dụng, mà còn là người lãnh đạo, định hình xu hướng và hỗ trợ người khác trên con đường của họ. Bạn liên tục cập nhật những cải tiến kỹ thuật số mới nhất và đang mở rộng ranh giới trong hành trình sáng tạo của mình. Mặc dù bạn là hình mẫu trong cộng đồng của mình, bạn vẫn cởi mở và tiếp thu những ý tưởng mới để đảm bảo rằng bạn luôn sẵn sàng để tiến xa hơn trong việc đổi mới sáng tạo.
        </div>
      </div>
    </>
  );
}
